import { PAYMENT_PLANS } from '@entities/payment-plan';
import { TFunction } from 'i18next';

export const getLangObjFromLang = (lang) => {
  let langObj = { locale: 'en', displayName: 'English', direction: 'ltr' };
  if (lang === 'ar') {
    langObj = { locale: 'ar', displayName: 'العربية', direction: 'rtl' };
  } else if (lang === 'es') {
    langObj = { locale: 'es', displayName: 'Español', direction: 'ltr' };
  } else if (lang === 'fr') {
    langObj = { locale: 'fr', displayName: 'Français', direction: 'ltr' };
  } else if (lang === 'id') {
    langObj = { locale: 'id', displayName: 'Indonesian', direction: 'ltr' };
  } else if (lang === 'ms') {
    langObj = { locale: 'ms', displayName: 'Malay', direction: 'ltr' };
  } else if (lang === 'tr') {
    langObj = { locale: 'tr', displayName: 'Turkish', direction: 'ltr' };
  } else if (lang === 'no') {
    langObj = { locale: 'no', displayName: 'Norwegian', direction: 'ltr' };
  } else if (lang === 'kr') {
    langObj = { locale: 'kr', displayName: 'کوردی', direction: 'rtl' };
  } else if (lang === 'pt') {
    langObj = { locale: 'pt', displayName: 'Português', direction: 'ltr' };
  }

  return langObj;
};

export const getPlanData = (
  planType: keyof typeof PAYMENT_PLANS,
  operatorSelectedDetails: any,
  t: TFunction
) => {
  const planMap = {
    [PAYMENT_PLANS.daily]: {
      name: t('daily_plan'),
      price: operatorSelectedDetails.dailyText,
      secondPrice: operatorSelectedDetails.dailySecondText,
    },

    [PAYMENT_PLANS.weekly]: {
      name: t('weekly_plan'),
      price: operatorSelectedDetails.weeklyText,
      secondPrice: operatorSelectedDetails.weeklySecondText,
    },

    [PAYMENT_PLANS.monthly]: {
      name: t('monthly_plan'),
      price: operatorSelectedDetails.monthlyText,
      secondPrice: operatorSelectedDetails.monthlySecondText,
    },

    [PAYMENT_PLANS.quarterly]: {
      name: t('quarterly_plan'),
      price: operatorSelectedDetails.quarterlyText,
      secondPrice: operatorSelectedDetails.quarterlySecondText,
    },

    [PAYMENT_PLANS.semiannually]: {
      name: t('semiannually_plan'),
      price: operatorSelectedDetails.semiannuallyText,
      secondPrice: operatorSelectedDetails.semiannuallySecondText,
    },

    [PAYMENT_PLANS.yearly]: {
      name: t('yearly_plan'),
      price: operatorSelectedDetails.yearlyText,
      secondPrice: operatorSelectedDetails.yearlySecondText,
    },
  };

  return planMap[planType] || null;
};
